<ul class="c-list c-list--inline">
	<li class="c-list__item" *ngFor="let lang of vm.languages ; let $index=index" style="margin-right: 3px; margin-left: 1px;">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<div class="{{vm.getFlagCss(lang)}}"></div>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<p class="c-text c-text--uppercase u-osr-xs">{{ lang }}</p>
			</div>
		</div>
	</li>
</ul>
